import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Payment from "@/pages/Payment";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";

import { LanguageProvider } from "@/context/LanguageContext";
import { api } from "@/lib/api";

// scroll to hash / top on route change
const ScrollHandler = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

const Shell = () => {
  const [packages, setPackages] = useState([]);
  const [settings, setSettings] = useState(null);
  const [feedback, setFeedback] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const [p, s, f] = await Promise.all([
          api.get("/packages"),
          api.get("/settings"),
          api.get("/feedback"),
        ]);
        if (!alive) return;
        // sort packages by order asc
        const sorted = (p.data || []).slice().sort(
          (a, b) => (a.order || 0) - (b.order || 0)
        );
        setPackages(sorted.filter((x) => x.active !== false));
        setSettings(s.data || {});
        setFeedback(f.data || []);
      } catch (e) {
        // fail silently; sections show empty
        console.error("Failed to load site data", e);
      }
    };
    load();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="App bg-app">
      <Navbar />
      <ScrollHandler />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              packages={packages}
              settings={settings}
              feedback={feedback}
            />
          }
        />
        <Route path="/booking" element={<Booking packages={packages} />} />
        <Route
          path="/payment"
          element={<Payment settings={settings} />}
        />
        <Route path="/success" element={<Success />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Footer settings={settings} />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
